import React from "react";

export default function TableSkeleton({ columns = [], rows = 5 }) {
  return (
    <>
      {Array.from({ length: rows }).map((_, rowIndex) => (
        <tr className="is-loading" key={rowIndex}>
          {columns.map((column) => (
            <td key={column.id || column.accessor || column.header || rowIndex}>
              <span className="new-data-table__skeleton" />
            </td>
          ))}
        </tr>
      ))}
    </>
  );
}
